module.exports = "<p>\r\n  nav-bar works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/_shared/nav-bar/nav-bar.component.html
// module id = ../../../../../src/app/_shared/nav-bar/nav-bar.component.html
// module chunks = main